<div class="verificationContainer">
  <div class="verification__title vc-text-l" i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.TITLE">Verification</div>
  <div class="vc-text-m" i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.ENTER_DIGITS">
    Please enter the 6 digits code that have been sent by email:
  </div>
  <div *ngIf="data?.email" class="verification__email vc-text-m">
    {{ data?.email }}
  </div>
  <a
    href="https://faq.vestiairecollective.com/hc/{{ lang }}/requests/new?ticket_form_id=360000195337"
    class="verification__link verification__link--email vc-link vc-text-m"
    i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.CHANGE_YOUR_EMAIL"
  >
    Change your email ?
  </a>
  <form
    class="verificationCodeWrapper"
    [ngClass]="{
      error: error
    }"
    name="code-verification"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <div class="vc-text-s error__msg" i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.CODE_EXPIRED">Code expired</div>
    <div class="verification__code">
      <div class="verification__code__item vc-text-m verification__code__item--disabled">V</div>
      <div class="verification__code__item vc-text-m verification__code__item--disabled">C</div>

      <div class="inputContainer">
        <input
          class="verification__code__item verification__code__item--input vc-text-m"
          maxlength="6"
          [formControl]="input"
          [ngClass]="{full: input?.value.length >= 6}"
        />
        <ng-container *ngFor="let item of [].constructor(6); let i = index">
          <div
            class="verification__code__item vc-text-m "
            [ngClass]="{'verification__code__item--disabled ': !(input?.value)[i]}"
          >
            {{ (input?.value)[i] ? '' : '-' }}
          </div>
        </ng-container>
      </div>
    </div>
  </form>
  <button
    class="verification__link vc-link"
    *ngIf="!newCodeIsSent"
    (click)="sendNewCode()"
    i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.SEND_NEW_CODE"
  >
    Send me a new code
  </button>
  <div
    class="verification__link vc-text-m"
    *ngIf="newCodeIsSent"
    i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.CODE_HAS_BEEN_SENT"
  >
    Code has been sent, if not received please check your spam.
  </div>
  <button
    for="code-verification"
    type="submit"
    class="vc-btn vc-btn--primary vc-btn--small vc-btn--full vc-btn--notfull--md-up submitBtn"
    (click)="onSubmit()"
    [disabled]="!input.valid"
    i18n="@@GET_PAID.CODE_VERIFICATION_MODAL.CONFIRM_BUTTON"
  >
    Confirm
  </button>
</div>
